import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { get } from "../../api/axios";
import { Link } from "react-router-dom";
import { checkPermission } from "../auth/ProtectedRoutes";

const Notifications = () => {
  const columns = [
    {
      title: "الرقم ",
      dataIndex: "id",
    },
    {
      title: "عنوان الإشعار",
      dataIndex: "title",
    },
    {
      title: "محتوى الإشعار",
      dataIndex: "content",
    },
    {
      title: "محتوى الإشعار",
      dataIndex: "source",
    },
    {
      title: "محتوى الإشعار",
      dataIndex: "trigger",
    },
    {
      title: "مستلم الإشعار",
      dataIndex: "receiver",
    },
  ];

  if (checkPermission("update-notification-content")) {
    columns.push(
      {
        title: "تعديل",
        dataIndex: "id",
        render: id => (
          <button className="btn btn-outline-warning btn-sm p-0">
            <Link
              className="color-inherit text-decoration-none py-1 px-2 d-block"
              to={`/notification-contents/edit/${id}`}
            >
              تعديل
            </Link>
          </button>
        ),
      },
    );
  }

  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    get("notification-contents?page=1").then(res => {
      setdata(res.data.data);
      //console.log(res)
      setLoading(false);
    });
  }, []);

  return (
    <div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              locale={{ emptyText: "لا يوجد عناصر" }}
              loading={loading}
              pagination={false}
              scroll={{
                y: "65vh",
                x: 650,
              }}
              columns={columns}
              dataSource={data}
              size="middle"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
